import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-server-error-page",
  templateUrl: "./ServerErrorPage.html",
})
export class ServerErrorPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

  public get errorMessage() {
    return this._appController.latestErrorMessage;
  }

}
